import src from "IMAGE";
export default { src, width: 495, height: 94, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AAoPGh8HDBQbBgoTHAoMFyJ8XaXBgViZvgsIFkYFBAwtAAoPGiEKDxslBwwXIwsOHCtyX6nBd1ibvAoIFD8HBhA9fCcMvWzGWGIAAAAASUVORK5CYII="};
